import { createAsyncThunk } from '@reduxjs/toolkit';
import { ASSIGN_PATHOLOGIST_TO_WSI } from '../../../custom/constant';

const assignPathologistApi = createAsyncThunk('pathologistUser/post', async (obj) => {
  try {
    const url = ASSIGN_PATHOLOGIST_TO_WSI;
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(obj),
    });

    // Check if the response is ok
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Return the response data
    return await response.json();
  } catch (error) {
    // Handle and return the error
    return Promise.reject(error);
  }
});

export default assignPathologistApi;
